import { useMutation, useQueryClient } from "@tanstack/react-query";
import resumeRepositoryService from "../services/resumeRepositoryService";
import { RESUME_QUERY_KEYS } from "./useResumeSearch";

const useResumeUpload = () => {
  const queryClient = useQueryClient();

  const uploadMutation = useMutation({
    mutationFn: (formData) => resumeRepositoryService.uploadResume(formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [RESUME_QUERY_KEYS.search] });
    },
  });

  const bulkUploadMutation = useMutation({
    mutationFn: (formData) => resumeRepositoryService.bulkUploadResumes(formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [RESUME_QUERY_KEYS.search] });
    },
  });

  return { uploadMutation, bulkUploadMutation };
};

export default useResumeUpload;
